import { getDefaultStore, useAtomValue } from "jotai";
import { type ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";

import { generalsAtom, useGeneralSupportSection } from "./constants";

type GeneralSupportProps = { content: ReactNode; id: string };
const store = getDefaultStore();

export default function GeneralSupport(props: GeneralSupportProps) {
    const { content, id } = props;
    const section = useGeneralSupportSection(id);
    const element = useAtomValue(section.element);

    useEffect(() => {
        store.set(generalsAtom, (c) => {
            if (c === section) return c;
            if (c === null) return section;
            else throw new Error("General support section already set");
        });
        return () => {
            store.set(generalsAtom, () => null);
        };
    }, [section]);

    if (!element) return null;
    return createPortal(content, element);
}

// const { general, hasSpecial, registerGeneral } = useContext(SupportZonePortalContext);
// useLayoutEffect(() => registerGeneral(), [registerGeneral]);
// if (!general) return null;

// const contentCss = css({
//     opacity: hasSpecial ? 0 : 1,
//     transition: `opacity ${SUPPORT_TRANSITION_MS}ms ${SUPPORT_TRANSITION_EASING}`,
//     pointerEvents: hasSpecial ? "none" : "auto",
//     "@media (prefers-reduced-motion: reduce)": {
//         transition: "none",
//     },
// });
